import React from 'react'
import DefaultEntityConsult from 'components/form/DefaultEntityConsult'
import Cultura from 'entity/Cultura'

export default function CulturaConsulta() {
    return (
        <DefaultEntityConsult
            EntityClass={Cultura}
            initialFilters={{ status: "ATIVO" }}
            titulo="Culturas"
            routeForm="_cultura"
            showEdit={true}
            showDelete={true}
        />
    )
}
